const FUNCTION_KEY_HEADER = 'x-functions-key';

const getApiBaseUrl = () => String(process.env.REACT_APP_API_URL || '').trim();

const getFunctionKey = () => String(process.env.REACT_APP_API_KEY || '').trim();

const getWindowOrigin = () => (
  typeof window !== 'undefined' && window.location?.origin
    ? window.location.origin
    : 'http://localhost'
);

const normalizeUrlDetails = (rawUrl = '', fallbackBase = getApiBaseUrl()) => {
  try {
    const parsed = new URL(String(rawUrl || ''), fallbackBase || getWindowOrigin());
    return {
      isAbsolute: /^https?:\/\//i.test(String(rawUrl || '').trim()),
      origin: parsed.origin.toLowerCase(),
    };
  } catch (_) {
    const raw = String(rawUrl || '').trim();
    return {
      isAbsolute: /^https?:\/\//i.test(raw),
      origin: '',
    };
  }
};

export const shouldAttachFunctionKey = (requestUrl = '', fallbackBase = getApiBaseUrl()) => {
  const apiBaseUrl = getApiBaseUrl();

  if (!apiBaseUrl) {
    return false;
  }

  const requestDetails = normalizeUrlDetails(requestUrl, fallbackBase || apiBaseUrl);
  const apiDetails = normalizeUrlDetails(apiBaseUrl, getWindowOrigin());

  if (!requestDetails.isAbsolute) {
    return true;
  }

  return Boolean(apiDetails.origin && requestDetails.origin === apiDetails.origin);
};

export const getFunctionKeyHeaders = (requestUrl = '', fallbackBase = getApiBaseUrl()) => {
  const functionKey = getFunctionKey();

  if (!functionKey || !shouldAttachFunctionKey(requestUrl, fallbackBase)) {
    return {};
  }

  return { [FUNCTION_KEY_HEADER]: functionKey };
};

export const mergeFunctionKeyHeaders = (headers = {}, requestUrl = '', fallbackBase = getApiBaseUrl()) => ({
  ...headers,
  ...getFunctionKeyHeaders(requestUrl, fallbackBase),
});
